import React from 'react';
import cx from 'classnames';
import styles from '../InputWrapper.module.scss';
export const InputWrapperButton = ({ children, ...props }) => (<div className={cx(styles.additional, styles.append, styles.active)}>
		<button type="button" {...props}>
			{children}
		</button>
	</div>);
